import { Icon } from "../../components/BaseComponents/Icon";

export const HousePercentageIcon = (props) => (
	<Icon fill="none" viewBox="0 0 56 56" {...props}>
		<path
			fill="url(#housePercentageIconGradient)"
			d="M56 28a28 28 0 1 1-56 0 28 28 0 0 1 56 0Z"
		/>
		<path
			fill="#fff"
			d="m44.49 24.45-.04-.03-15.58-13.1a1.4 1.4 0 0 0-1.8 0L11.5 24.43a1.48 1.48 0 0 0-.18 2.03 1.4 1.4 0 0 0 1.98.22l1.93-1.63v16.5a1.44 1.44 0 0 0 1.41 1.46h22.67a1.44 1.44 0 0 0 1.41-1.46v-16.5l1.94 1.63a1.4 1.4 0 0 0 2-.17 1.48 1.48 0 0 0-.17-2.05Z"
		/>
		<path
			fill="#0756C0"
			d="M28.87 34.53a3.1 3.1 0 0 1 3.07-3.13A3.1 3.1 0 0 1 35 34.53a3.1 3.1 0 0 1-3.06 3.13 3.1 3.1 0 0 1-3.07-3.13Zm4.55 0a1.5 1.5 0 0 0-1.48-1.52 1.5 1.5 0 0 0-1.49 1.52c0 .84.66 1.52 1.49 1.52a1.5 1.5 0 0 0 1.48-1.52ZM21 28.47a3.1 3.1 0 0 1 3.06-3.13 3.1 3.1 0 0 1 3.07 3.13 3.1 3.1 0 0 1-3.07 3.13A3.1 3.1 0 0 1 21 28.47Zm4.55 0a1.5 1.5 0 0 0-1.49-1.52 1.5 1.5 0 0 0-1.48 1.52c0 .84.66 1.51 1.48 1.51a1.5 1.5 0 0 0 1.49-1.51Zm-1.67 8.89L30.73 25l1.37.64L25.25 38l-1.37-.64Z"
		/>
		<defs>
			<linearGradient
				id="housePercentageIconGradient"
				x1="28"
				x2="28"
				y1="0"
				y2="56"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0756C0" />
				<stop offset="1" stopColor="#2F97F4" />
			</linearGradient>
		</defs>
	</Icon>
);
